module.exports = __webpack_public_path__ + "img/healthProMobile1.f921e170.png";